import { ICellRendererParams } from '@ag-grid-community/core'
import { DownOutlined } from '@ant-design/icons'
import { Button } from '@sureco/design-system'
import { Button as AntButton, Dropdown } from 'antd'
import type { MenuProps } from 'antd'
import React, { useState } from 'react'
import { CensusFileWithRowStatsDto } from '../api/dto/census-file-with-row-stats.dto'
import HideFromHRModal from './HideFromHRModal'

const HIDE_FROM_HR_MENU_ITEMS: MenuProps['items'] = [
  { key: 'hide-from-hr', label: 'Hide from HR' },
]

function ReviewActionsCell({
  params,
  clickView,
  isSurecoAdmin,
}: {
  params: ICellRendererParams<CensusFileWithRowStatsDto>
  clickView: (publicKey: string) => void
  isSurecoAdmin: boolean
}) {
  const [modalOpen, setModalOpen] = useState(false)
  const publicKey = params.data?.publicKey
  const hiddenFromHR = !!params.data?.hiddenFromHR

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'stretch',
        marginLeft: 'auto',
      }}
    >
      <Button
        onClick={() => publicKey && clickView(publicKey)}
        style={
          isSurecoAdmin
            ? { borderTopRightRadius: 0, borderBottomRightRadius: 0 }
            : undefined
        }
      >
        Review
      </Button>
      {isSurecoAdmin && publicKey && (
        <>
          <Dropdown
            menu={{
              items: HIDE_FROM_HR_MENU_ITEMS,
              onClick: () => setModalOpen(true),
            }}
            trigger={['click']}
          >
            <AntButton
              icon={<DownOutlined />}
              onClick={(e) => e.preventDefault()}
              style={{
                height: 'auto',
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            />
          </Dropdown>
          <HideFromHRModal
            open={modalOpen}
            publicKey={publicKey}
            fileName={params.data?.fileName}
            hiddenFromHR={hiddenFromHR}
            onClose={() => setModalOpen(false)}
            onChanged={() => params.api.refreshServerSide({ purge: true })}
          />
        </>
      )}
    </div>
  )
}

export default ReviewActionsCell
